<template>
  <div class="living-options-subsections">
    <div class="row">
      <div class="col-12">
        <div class="subsections">
          <h3>Releases</h3>
          <button class="btn btn-sm btn-primary mb-4" @click="addSubsection">Add Release</button>
          
          <div class="row mb-4">
            <div class="col-6">
              <div class="status-option">
                <input type="checkbox" id="active" value="Active" v-model="filterActiveStates">
                <label class="status-option__label" for="active">Active</label>
              </div>
              
              <div class="status-option">
                <input type="checkbox" id="inactive" value="Inactive" v-model="filterActiveStates">
                <label class="status-option__label" for="inactive">Inactive</label>
              </div>
            </div>
          </div>
          
          <div class="mb-2">
            <input class="form-control" type="text" v-model="subsectionFilterText" placeholder="Filter subsections">
          </div>

          <v-table
            :columns="[
              { label: 'Label', field: 'label'},
              { 
                label: 'Visually Hidden',
                field: 'isVisuallyHidden',
                options: {
                  sortable: true,
                  return: function (fieldValue) {
                    if (fieldValue) {
                      return `<div class='status status--sold'>Hidden</div>`
                    } else {
                      return `<div class='status status--available'>Visible</div>`
                    }
                  }
                }
              },
              { 
                label: 'Sold Out',
                field: 'properties',
                options: {
                  sortable: true,
                  return: function (fieldValue) {
                    if (fieldValue) {
                      const availableProperties = fieldValue.filter(property => property.status === 'Available')
                      if (!availableProperties.length) {
                        return `<div class='status status--sold'>Available properties: ${availableProperties.length}</div>`
                      } else {
                        return `<div class='status status--available'>Available properties: ${availableProperties.length}</div>`
                      }
                    } else {
                      return `<div class='status status--sold'>Available: 0</div>`
                    }
                  }
                }
              },
              {
                label: 'Associated Properties',
                field: 'propertyIds',
                sortField: 'propertyIds.length',
                options: {
                  sortable: true,
                  return: function (fieldValue) {
                    if (fieldValue.length) {
                      return fieldValue.length
                    } else {
                      return '-'
                    }
                  }
                }
              },
            ]"
            :rows="filteredSubsections"
            :show-active-toggle="activeUser.access.indexOf('live-toggle') !== -1"
            save-action="SAVE_SUBSECTION"
            @edit="editSubsection($event._id)"
            @delete="deleteSubsection($event._id)"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import VTable from '@/components/VTable'

export default {
  components: {
    VTable,
  },
  
  data () {
    return {
      activeSubsectionId: null,
      subsectionFilterText: '',
      filterActiveStates: []
    }
  },

  computed: {
    ...mapGetters([
      'subsections'
    ]),

    activeUser () {
      return this.$store.getters.user
    },

    filteredSubsections () {
      let filtered = this.subsections.filter(subsection => subsection.label.toLowerCase().includes(this.subsectionFilterText.toLowerCase()))

      if (this.filterActiveStates.length) {
        filtered = filtered.filter(item => (this.filterActiveStates.includes('Active') && item.active) || (this.filterActiveStates.includes('Inactive') && !item.active))
      }

      return filtered
    },
  },

  created () {
    this.$store.dispatch('FETCH_SUBSECTIONS')
  },

  methods: {
    async addSubsection () {
      const newSubsection = await this.$store.dispatch('ADD_NEW_SUBSECTION')
      this.$store.dispatch('SAVE_SUBSECTION', newSubsection)
      this.editSubsection(newSubsection._id)
    },      

    editSubsection (id) {
      this.$router.push(`subsections/${id}`)
    },

    deleteSubsection (id) {
      if (confirm('Are you sure?')) {
        this.$store.dispatch('DELETE_SUBSECTION', id)
      }
    },
  },
}
</script>
